(function () {
  'use strict';

  angular
    .module('otpReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('otpReport', {
        url: '/otp-report',
        views:{
        	'otpReportView' : {
        		templateUrl: 'otp-report/views/otp-report.tpl.html',
                controller: 'OtpReportCtrl',
                controllerAs: 'otpReport'
        	}
        }
      });
  }
}());
